import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { ScopedTooltip } from '../../components/TooltipDecorator/ScopedTooltip';
import { Bem } from '../../service/Bem/Bem';
import {
    getRetargetingConditionsText,
    getRetargetingConditionTypeText
} from '../../service/RetargetingHelpers/RetargetingHelpers';
import { BasePopupProps } from '../../typings/common';
import { CopyTooltipStatus, RetargetingConditionRule } from '../../typings/domain';
import { PopupDecorator } from '../PopupDecorator/PopupDecorator';
import { Shape2, Shape2Icon, Shape2Theme } from '../Shape2/Shape2';
import { StyledLink, StyledLinkTheme } from '../StyledLink/StyledLink';

import './RetargetingRulesInfoTooltip.css';
import * as keyset from './RetargetingRulesInfoTooltip.i18n';

const i18n = i18nFactory(keyset);

const BLOCK = 'retargeting-rules-info-tooltip';

export interface RetargetingRulesInfoTooltipProps {
    conditionRules: Array<RetargetingConditionRule>;
    copyTooltipStatus: CopyTooltipStatus;
    onCopy: () => void;
}

export class RetargetingRulesInfoTooltip extends React.PureComponent<
    RetargetingRulesInfoTooltipProps & BasePopupProps
> {
    private popupAnchor?: React.ReactNode;
    private copiedTooltipAnchor?: React.ReactNode;

    render() {
        const { openPopup } = this.props;

        return (
            <>
                <StyledLink
                    theme={StyledLinkTheme.grey}
                    cls={Bem.cls(BLOCK, 'link')}
                    onClick={openPopup}
                    ref={ref => (this.popupAnchor = ref)}
                >
                    {i18n('open-popup-text')}
                    <Shape2
                        icon={Shape2Icon.info}
                        theme={Shape2Theme.default}
                        width={12}
                        height={12}
                        cls={Bem.cls(BLOCK, 'icon')}
                    />
                </StyledLink>
                {this.getPopup()}
            </>
        );
    }

    private getPopup = () => {
        const { isPopupVisible, closePopup, onCopy, copyTooltipStatus } = this.props;

        return (
            <PopupDecorator
                cls={Bem.cls(BLOCK, 'popup')}
                onClose={closePopup}
                target={'anchor'}
                anchor={this.popupAnchor}
                directions={['right-top', 'right-center', 'right-bottom']}
                visible={isPopupVisible}
                hasTail={true}
                hasClose={true}
                onOutsideClick={closePopup}
                header={i18n('popup-title')}
            >
                {this.renderPopUpDescription()}
                <StyledLink
                    theme={StyledLinkTheme.grey}
                    cls={Bem.cls(BLOCK, 'link-copy')}
                    onClick={onCopy}
                    ref={ref => (this.copiedTooltipAnchor = ref)}
                >
                    <Shape2
                        icon={Shape2Icon.copy}
                        theme={Shape2Theme.default}
                        width={16}
                        height={16}
                        cls={Bem.cls(BLOCK, 'icon-copy')}
                    />
                    {i18n('copy-link')}
                </StyledLink>
                <ScopedTooltip
                    anchor={this.copiedTooltipAnchor}
                    theme={copyTooltipStatus === CopyTooltipStatus.error ? 'error' : 'normal'}
                    view={'classic'}
                    tone={'default'}
                    to={'right'}
                    size={'s'}
                    visible={copyTooltipStatus !== CopyTooltipStatus.hidden}
                >
                    {copyTooltipStatus === CopyTooltipStatus.error ? i18n('copy-error') : i18n('copied')}
                </ScopedTooltip>
            </PopupDecorator>
        );
    };

    private renderPopUpDescription = () => {
        return this.props.conditionRules.map((conditionItem, index) => {
            const { type, goals } = conditionItem;

            return (
                <div className={Bem.cls(BLOCK, 'popup-description')} key={index}>
                    <div className={Bem.cls(BLOCK, 'popup-title-description')}>
                        {`${getRetargetingConditionTypeText(type)}:`}
                    </div>
                    <div className={Bem.cls(BLOCK, 'popup-text-description')}>
                        {getRetargetingConditionsText(goals)}.
                    </div>
                </div>
            );
        });
    };
}
